export const DsfUploadFile = dsf.defineAsyncComponent("DsfUploadFile", () =>
  import(/* webpackChunkName: "platform_pc_upload" */ "./uploadFile")
);
export const DsfUploadImg = dsf.defineAsyncComponent("DsfUploadImg", () =>
  import(/* webpackChunkName: "platform_pc_upload" */ "./uploadImg")
);
export const DsfUploadPhoto = dsf.defineAsyncComponent("DsfUploadPhoto", () =>
  import(/* webpackChunkName: "platform_pc_upload" */ "./uploadPhoto")
);

export const DsfCustomerImg = dsf.defineAsyncComponent("DsfCustomerImg", () =>
  import(/* webpackChunkName: "platform_pc_upload" */ "./customerImg.vue")
);
export const pcCropImage = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_upload" */ "./cropImage.vue")
);
export const pictureCutDialog = Vue.defineAsyncComponent(() =>
  import(/* webpackChunkName: "platform_pc_upload" */ "./pictureCutDialog.vue")
);
